let lastScrollTime = 0;
const SCROLL_THROTTLE_MS = 100;

function handleScroll(event) {
  let data;
  try {
    data = JSON.parse(event.data);
  } catch (e) {
    return;
  }

  if (data.source !== "flutter-child") return;

  const now = Date.now();

  switch (data.action) {
    case "flutter-scroll-boundary":
      if (now - lastScrollTime > SCROLL_THROTTLE_MS) {
        window.scrollBy({
          top: data.direction === "top" ? -data.delta * 9 : data.delta * 9,
          behavior: "smooth",
        });
        lastScrollTime = now;
        isParentScrolling = true;
      }
      break;

    case "flutter-scroll-end":
    case "flutter-scroll-stop":
      isParentScrolling = false;
      break;
  }
}


window.addEventListener("message", handleScroll);


